
import CSearchList from '@/components/c-search-list'
import CTable from '@/components/c-table'
import { getIndexConfig, getTableConfig, inputList } from './config'
import { usePagination } from '@/hooks/usePagination'
import { defineComponent, reactive, toRefs, onMounted, computed } from 'vue'
import { logPage } from '../api'
import { useEnterpriseRemote } from '../../enterprise-remote'
import { toResult } from '@/utils/toResult'

export default defineComponent({
  components: {
    CSearchList,
    CTable
  },
  setup() {
    const remoteData1 = useEnterpriseRemote()
    const data = reactive({
      ...getIndexConfig()
    })

    const inputListComputed = computed(() => inputList(remoteData1))

    const tableConfig = reactive({
      ...getTableConfig()
    })

    const getListFn = async () => {
      const p = {
        ...data.queryForm,
        currPage: tableConfig.pagination.currentPage,
        pageSize: tableConfig.pagination.pageSize
      }
      const [err, res] = await toResult(logPage(p))
      if (err) return false
      tableConfig.data = res.list || []
      tableConfig.pagination.total = res.total || 0
    }

    // 查询
    const handleSearch = (params) => {
      tableConfig.pagination.currentPage = 1
      params && (data.queryForm = { ...params })
      getListFn()
    }

    // 重置
    const handleReset = (val) => {
      data.queryForm = val
    }

    const { pageCurrentChange, pageSizeChange } = usePagination(
      tableConfig.pagination,
      () => {
        getListFn()
      }
    )

    onMounted(() => {
      // 打开列表默认查询全部
      handleSearch({})
    })

    return {
      ...toRefs(data),
      inputListComputed,
      handleSearch,
      handleReset,
      tableConfig,
      pageCurrentChange,
      pageSizeChange,
      getListFn
    }
  }
})
